



































































































import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from "@/constants/booking_candidate"
import { STATUSES as QUESTIONNAIRE_ANSWER_STATUSES } from "@/constants/questionnaire_answer"
import BookingCandidateListItem from "./BookingCandidateListItem.vue"
import BookingCandidateListFilterForm from "./List/BookingCandidateListFilterForm.vue"
import BookingCandidateListFilterChip from "./List/BookingCandidateListFilterChip.vue"
import QDownloadBtn from "@/components/QDownloadBtn.vue"
import _ from "lodash"
import { BOOKING_PURPOSES } from "../../../constants/booking"

@Component({
  components: {
    BookingCandidateListItem,
    BookingCandidateListFilterForm,
    BookingCandidateListFilterChip,
    QDownloadBtn
  },
  computed: {
    ...mapState({
      loading: "loading"
    }),
    ...mapState("Auth", {
      candidate: "candidate"
    })
  }
})
export default class BookingCandidateList extends Vue {
  // candidate State
  candidate!: Model
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES
  questionnaireAnswerStatuses = QUESTIONNAIRE_ANSWER_STATUSES
  bookingPurposes = BOOKING_PURPOSES
  // Data
  options = {
    page: 1,
    itemsPerPage: 10,
    query: null,
    businessName: null,
    orderBy: null,
    orderByDirection: "asc",
    statuses: []
  }
  reload = 0
  headers = [
    {
      text: "Questionnaire",
      value: "booking.questionnaire.name",
      width: "35%"
    },
    {
      text: "Risk Profile",
      value: "booking.risk_profile.custom_job_role_name",
      align: "left",
      sortable: false,
      width: "30%"
    },
    {
      text: "Status",
      value: "status",
      align: "left",
      sortable: false,
      width: "15%"
    },
    {
      text: "Actions",
      value: "actions",
      align: "left",
      sortable: false,
      cellClass: "row-click-stop"
    }
  ]

  // Methods
  handleFetch() {
    const options = {
      params: {
        search_name: this.options.query,
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        sort:
          this.options.orderByDirection == "desc"
            ? "-" + this.options.orderBy
            : this.options.orderBy,
        statuses: this.options.statuses,
        business_name: this.options.businessName,
        expand: [
          "booking",
          "booking.questionnaire",
          "booking.request_business",
          "booking.risk_profile",
          "questionnaire_answer.report"
        ],
        candidate_oid: this.candidate.object_id
      }
    }
    return this.$store.dispatch("BookingCandidate/fetchList", options)
  }

  handleClick(item) {
    this.$router.push({
      name: "candidate-booking-candidate-read",
      params: {
        bookingCandidateOid: item.object_id
      }
    })
  }

  name(item) {
    if (!item.first_name && !item.last_name) {
      return null
    }
    return (item.first_name ?? "") + " " + (item.last_name ?? "")
  }

  toDownloadReport(item) {
    return this.$store
      .dispatch("BookingCandidate/fetch", item.object_id)
      .then(async response => {
        const bookingCandidate = response.data.data

        return await this.$store
          .dispatch(
            "QuestionnaireAnswer/downloadReport",
            bookingCandidate.questionnaire_answer.object_id
          )
          .then(response => {
            const blob = new Blob([response.data], { type: "application/pdf" })
            const link = document.createElement("a")
            link.href = URL.createObjectURL(blob)
            link.download = "Quescreen Report - " + this.name(item)
            link.click()
          })
      })
  }

  toDownloadAttachedReport(item) {
    return this.$store
      .dispatch("BookingCandidate/fetch", item.object_id)
      .then(async response => {
        const bookingCandidate = response.data.data

        return await this.$store
          .dispatch(
            "QuestionnaireAnswer/downloadAttachedReport",
            bookingCandidate.questionnaire_answer.object_id
          )
          .then(response => {
            const blob = new Blob([response.data], { type: "application/pdf" })
            const link = document.createElement("a")
            link.href = URL.createObjectURL(blob)
            link.download = "Quescreen Report - " + this.name(item)
            link.click()
          })
      })
  }

  toDownloadHCSReport(item) {
    return this.$store
      .dispatch("BookingCandidate/fetch", item.object_id)
      .then(async response => {
        const bookingCandidate = response.data.data

        return await this.$store
          .dispatch(
            "QuestionnaireAnswer/downloadHCSReport",
            bookingCandidate.questionnaire_answer.object_id
          )
          .then(response => {
            const blob = new Blob([response.data], { type: "application/pdf" })
            const link = document.createElement("a")
            link.href = URL.createObjectURL(blob)
            link.download = "Quescreen Report - " + this.name(item)
            link.click()
          })
      })
  }

  isQuestionnaireCompleted(item) {
    if (
      item.questionnaire_answer?.status &&
      [this.questionnaireAnswerStatuses.STATUS_COMPLETED.key].includes(
        item.questionnaire_answer.status
      )
    ) {
      return true
    }
    return false
  }

  showAutoGeneratedResult(item) {
    if (this.isQuestionnaireCompleted(item)) {
      return true
    }
    return false
  }

  showHCSResult(item) {
    if (
      this.isQuestionnaireCompleted(item) &&
      !item.questionnaire_answer?.is_awaiting_report &&
      item.booking.purpose ==
        this.bookingPurposes.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key
    ) {
      return true
    }
    return false
  }

  showAttachedResult(item) {
    if (
      this.isQuestionnaireCompleted(item) &&
      !item.questionnaire_answer?.is_awaiting_report &&
      !_.isEmpty(item.questionnaire_answer?.report)
    ) {
      return true
    }
    return false
  }

  fullReportName(item) {
    if (
      !item.booking.purpose ||
      item.booking.purpose == this.bookingPurposes.PURPOSE_PRE_EMPLOYMENT.key
    ) {
      return "Download Your Responses"
    }

    return "Download Full Report"
  }
}
